// ============================================================
// ALGORITMO DE RANKING — Radar Profissional da Nova Economia™
//
// As chaves do PROFESSION_MATRIX devem corresponder exatamente
// aos campos `name` em src/data/professions.js.
//
// Escala de valores da matriz:
//   9-10  — requisito primário (core da profissão)
//   7-8   — forte secundário (muito desejável)
//   4-5   — moderado (não atrapalha nem ajuda muito)
//   2-3   — fraco (pouco relevante)
//   1     — anti-padrão (incompatível com a profissão)
// ============================================================

import { QUESTIONS } from "@/components/vocational/vocationalData";

const PROFESSION_MATRIX = {
  // ── Conteúdo & Criação ────────────────────────────────────────────────────
  "Copywriter": {
    cognitive:    { creative:10, analytic:2, strategic:3, executor:4 },
    operational:  { autonomous:10, adaptive:5, routine:1, commercial:2 },
    behavioral:   { backstage:8, hybrid:6, communicator:5, frontline:1, sales_high:1, sales_low:8, sales_medium:3, leader:1, operator:2 },
    motivational: { autonomy:10, impact:5, ambition:3, security:1 },
    risk:         { high:3, medium:7, low:2 },
    baggage:      { humanities:10, writing:10, management:1, analysis:1, visual:3, tech:1, sales:2, design:3 },
  },
  "Redator": {
    cognitive:    { creative:9, analytic:2, strategic:2, executor:3 },
    operational:  { autonomous:10, adaptive:4, routine:2, commercial:1 },
    behavioral:   { backstage:9, hybrid:4, communicator:5, frontline:1, sales_high:1, sales_low:9, sales_medium:2, leader:1, operator:2 },
    motivational: { autonomy:9, impact:6, ambition:2, security:2 },
    risk:         { high:2, medium:7, low:3 },
    baggage:      { humanities:10, writing:10, management:1, analysis:1, visual:2, tech:1, sales:1, design:2 },
  },
  "Estrategista de Conteúdo": {
    cognitive:    { strategic:10, creative:8, analytic:2, executor:1 },
    operational:  { adaptive:9, autonomous:3, routine:1, commercial:1 },
    behavioral:   { hybrid:9, communicator:8, leader:3, backstage:1, frontline:1, sales_high:1, sales_low:2, sales_medium:3, operator:2 },
    motivational: { autonomy:9, impact:7, ambition:2, security:1 },
    risk:         { medium:7, high:3, low:1 },
    baggage:      { humanities:10, writing:10, management:2, analysis:2, visual:2, tech:1, sales:1, design:2 },
  },
  "Social Media": {
    cognitive:    { creative:9, analytic:3, strategic:4, executor:4 },
    operational:  { adaptive:9, routine:2, commercial:3, autonomous:5 },
    behavioral:   { frontline:5, communicator:9, hybrid:8, backstage:1, sales_high:2, sales_medium:5, sales_low:2, leader:2, operator:2 },
    motivational: { autonomy:8, impact:5, ambition:3, security:1 },
    risk:         { high:3, medium:7, low:2 },
    baggage:      { humanities:8, writing:8, management:2, analysis:2, visual:8, tech:1, sales:2, design:5 },
  },

  // ── Design & Vídeo ────────────────────────────────────────────────────────
  "Designer": {
    cognitive:    { creative:10, analytic:2, strategic:1, executor:3 },
    operational:  { autonomous:10, routine:2, adaptive:4, commercial:1 },
    behavioral:   { backstage:10, hybrid:3, communicator:1, frontline:1, sales_high:1, sales_low:9, sales_medium:2, leader:1, operator:3 },
    motivational: { autonomy:10, impact:3, ambition:2, security:2 },
    risk:         { high:3, medium:6, low:3 },
    baggage:      { design:10, visual:10, humanities:2, writing:1, management:1, analysis:1, tech:2, sales:1 },
  },
  "Web Designer": {
    cognitive:    { creative:8, executor:5, analytic:3, strategic:1 },
    operational:  { autonomous:9, adaptive:4, routine:2, commercial:1 },
    behavioral:   { backstage:9, operator:4, hybrid:2, frontline:1, sales_high:1, sales_low:8, sales_medium:1, leader:1, communicator:1 },
    motivational: { autonomy:9, security:3, ambition:2, impact:2 },
    risk:         { medium:6, low:4, high:1 },
    baggage:      { design:10, visual:9, tech:8, writing:1, management:1, analysis:2, humanities:1, sales:1 },
  },
  "Videomaker": {
    cognitive:    { creative:9, analytic:2, strategic:1, executor:5 },
    operational:  { autonomous:10, adaptive:4, routine:1, commercial:1 },
    behavioral:   { backstage:9, hybrid:3, communicator:2, frontline:1, sales_high:1, sales_low:8, sales_medium:2, leader:1, operator:2 },
    motivational: { autonomy:10, impact:4, ambition:2, security:1 },
    risk:         { high:3, medium:6, low:3 },
    baggage:      { design:9, visual:10, humanities:3, writing:2, management:1, analysis:1, tech:3, sales:1 },
  },
  "Editor de Vídeos": {
    cognitive:    { executor:9, creative:3, analytic:2, strategic:1 },
    operational:  { routine:7, autonomous:5, adaptive:2, commercial:1 },
    behavioral:   { backstage:10, operator:7, hybrid:1, frontline:1, sales_high:1, sales_low:10, sales_medium:1, leader:1, communicator:1 },
    motivational: { autonomy:6, security:4, impact:1, ambition:1 },
    risk:         { medium:5, low:5, high:1 },
    baggage:      { visual:10, design:8, tech:2, humanities:1, writing:1, management:1, analysis:1, sales:1 },
  },

  // ── Analytics & Performance ───────────────────────────────────────────────
  "Analista de Marketing": {
    cognitive:    { analytic:10, strategic:4, executor:2, creative:1 },
    operational:  { routine:7, adaptive:5, commercial:1, autonomous:1 },
    behavioral:   { operator:8, backstage:6, hybrid:3, communicator:2, sales_high:1, sales_low:7, sales_medium:3, leader:1, frontline:1 },
    motivational: { security:7, ambition:4, impact:2, autonomy:1 },
    risk:         { medium:7, low:5, high:1 },
    baggage:      { analysis:10, management:5, tech:4, humanities:3, writing:2, visual:1, sales:1, design:1 },
  },
  "Analista de E-mail Marketing": {
    cognitive:    { analytic:9, creative:3, executor:2, strategic:1 },
    operational:  { routine:8, adaptive:2, commercial:1, autonomous:1 },
    behavioral:   { backstage:9, operator:8, hybrid:2, communicator:2, sales_high:1, sales_low:8, sales_medium:1, leader:1, frontline:1 },
    motivational: { security:7, impact:2, ambition:1, autonomy:1 },
    risk:         { medium:6, low:5, high:1 },
    baggage:      { analysis:9, writing:8, tech:3, humanities:3, management:2, visual:1, sales:1, design:1 },
  },
  "Gestor de Tráfego": {
    cognitive:    { analytic:10, strategic:5, executor:3, creative:1 },
    operational:  { commercial:8, adaptive:5, routine:2, autonomous:1 },
    behavioral:   { operator:8, hybrid:3, backstage:2, communicator:2, sales_high:3, sales_medium:3, sales_low:1, leader:2, frontline:2 },
    motivational: { ambition:9, autonomy:2, impact:2, security:1 },
    risk:         { high:7, medium:6, low:1 },
    baggage:      { analysis:10, tech:7, management:2, writing:1, visual:1, humanities:1, sales:2, design:1 },
  },
  "Gestor de Marketing": {
    cognitive:    { strategic:10, analytic:4, creative:2, executor:1 },
    operational:  { adaptive:9, commercial:4, autonomous:2, routine:1 },
    behavioral:   { leader:10, communicator:9, hybrid:3, frontline:3, sales_high:2, sales_medium:3, sales_low:1, operator:1, backstage:1 },
    motivational: { ambition:10, impact:3, autonomy:2, security:1 },
    risk:         { medium:7, high:3, low:1 },
    baggage:      { management:10, analysis:4, humanities:3, writing:3, sales:3, tech:1, visual:1, design:1 },
  },
  "Estrategista Digital": {
    cognitive:    { strategic:10, analytic:4, creative:3, executor:1 },
    operational:  { adaptive:10, autonomous:3, commercial:3, routine:1 },
    behavioral:   { hybrid:9, communicator:8, leader:4, backstage:1, sales_high:1, sales_medium:3, sales_low:1, operator:2, frontline:2 },
    motivational: { ambition:10, autonomy:5, impact:3, security:1 },
    risk:         { high:8, medium:3, low:1 },
    baggage:      { management:7, analysis:7, writing:3, humanities:3, sales:3, tech:2, visual:1, design:1 },
  },
  "Analista de Infraestrutura de Marketing Digital": {
    cognitive:    { analytic:10, executor:8, strategic:2, creative:1 },
    operational:  { routine:10, adaptive:2, autonomous:2, commercial:1 },
    behavioral:   { backstage:10, operator:9, hybrid:1, frontline:1, sales_high:1, sales_low:10, sales_medium:1, leader:1, communicator:1 },
    motivational: { security:10, impact:2, autonomy:1, ambition:1 },
    risk:         { low:10, medium:3, high:1 },
    baggage:      { tech:10, analysis:10, management:4, writing:1, visual:1, humanities:1, sales:1, design:1 },
  },

  // ── Vendas & Comercial ────────────────────────────────────────────────────
  "Gestor Comercial": {
    cognitive:    { strategic:9, executor:8, analytic:3, creative:1 },
    operational:  { commercial:10, adaptive:5, routine:1, autonomous:3 },
    behavioral:   { leader:10, sales_high:10, frontline:10, communicator:9, hybrid:3, operator:2, backstage:1, sales_medium:3, sales_low:1 },
    motivational: { ambition:10, security:1, autonomy:4, impact:3 },
    risk:         { high:10, medium:3, low:1 },
    baggage:      { sales:10, management:10, analysis:3, writing:2, humanities:2, tech:1, visual:1, design:1 },
  },
  "Closer": {
    cognitive:    { executor:9, strategic:4, analytic:2, creative:2 },
    operational:  { commercial:10, adaptive:5, autonomous:4, routine:1 },
    behavioral:   { sales_high:10, frontline:10, communicator:10, leader:4, hybrid:2, operator:1, backstage:1, sales_medium:2, sales_low:1 },
    motivational: { ambition:10, autonomy:4, security:1, impact:2 },
    risk:         { high:10, medium:2, low:1 },
    baggage:      { sales:10, management:3, humanities:3, writing:4, analysis:1, visual:1, tech:1, design:1 },
  },
  "SDR": {
    cognitive:    { executor:10, analytic:3, strategic:2, creative:1 },
    operational:  { commercial:10, routine:4, adaptive:3, autonomous:1 },
    behavioral:   { sales_high:9, frontline:9, communicator:10, hybrid:3, leader:2, operator:2, backstage:1, sales_medium:3, sales_low:1 },
    motivational: { ambition:9, security:2, autonomy:2, impact:2 },
    risk:         { high:8, medium:4, low:1 },
    baggage:      { sales:10, humanities:4, management:2, writing:3, analysis:1, visual:1, tech:1, design:1 },
  },
  "BDR": {
    cognitive:    { executor:9, strategic:4, analytic:2, creative:1 },
    operational:  { commercial:10, adaptive:5, autonomous:2, routine:2 },
    behavioral:   { sales_high:9, frontline:9, communicator:9, leader:3, hybrid:3, operator:2, backstage:1, sales_medium:3, sales_low:1 },
    motivational: { ambition:9, security:1, autonomy:3, impact:2 },
    risk:         { high:8, medium:4, low:1 },
    baggage:      { sales:10, humanities:3, management:3, writing:2, analysis:2, visual:1, tech:2, design:1 },
  },
  "Vendedor de WhatsApp": {
    cognitive:    { executor:10, analytic:1, strategic:1, creative:2 },
    operational:  { commercial:10, routine:5, adaptive:2, autonomous:2 },
    behavioral:   { sales_high:10, frontline:8, communicator:10, hybrid:3, backstage:1, leader:1, operator:2, sales_medium:3, sales_low:1 },
    motivational: { ambition:8, security:3, autonomy:2, impact:1 },
    risk:         { high:5, medium:6, low:1 },
    baggage:      { sales:10, humanities:4, writing:3, management:1, analysis:1, visual:1, tech:1, design:1 },
  },
  "Social Seller": {
    cognitive:    { executor:6, creative:3, strategic:2, analytic:1 },
    operational:  { commercial:9, autonomous:2, adaptive:2, routine:1 },
    behavioral:   { communicator:10, sales_high:9, frontline:9, hybrid:2, leader:1, operator:1, backstage:1, sales_medium:2, sales_low:1 },
    motivational: { ambition:8, autonomy:4, impact:2, security:1 },
    risk:         { high:8, medium:3, low:1 },
    baggage:      { sales:9, humanities:3, writing:2, visual:2, management:1, analysis:1, tech:1, design:2 },
  },

  // ── Operações & Dados ─────────────────────────────────────────────────────
  "Sales Ops": {
    cognitive:    { analytic:10, strategic:6, executor:3, creative:1 },
    operational:  { routine:9, adaptive:3, commercial:2, autonomous:1 },
    behavioral:   { operator:10, backstage:7, hybrid:2, communicator:1, sales_high:1, sales_low:4, sales_medium:2, leader:1, frontline:1 },
    motivational: { security:8, ambition:3, impact:1, autonomy:1 },
    risk:         { low:7, medium:5, high:1 },
    baggage:      { analysis:10, management:10, tech:4, writing:1, humanities:1, visual:1, sales:3, design:1 },
  },
  "Analista de CRM": {
    cognitive:    { analytic:10, executor:4, strategic:4, creative:1 },
    operational:  { routine:10, adaptive:3, commercial:1, autonomous:1 },
    behavioral:   { operator:10, backstage:8, hybrid:3, communicator:2, sales_high:1, sales_low:8, sales_medium:2, leader:1, frontline:1 },
    motivational: { security:9, impact:3, ambition:2, autonomy:1 },
    risk:         { low:9, medium:4, high:1 },
    baggage:      { analysis:10, management:8, tech:5, humanities:2, writing:1, visual:1, sales:3, design:1 },
  },
  "Gestor de Produto Digital": {
    cognitive:    { strategic:10, analytic:7, creative:4, executor:2 },
    operational:  { adaptive:10, autonomous:5, commercial:1, routine:1 },
    behavioral:   { leader:9, hybrid:8, communicator:7, operator:3, sales_high:1, sales_medium:2, sales_low:1, backstage:1, frontline:2 },
    motivational: { impact:9, ambition:9, autonomy:6, security:1 },
    risk:         { high:8, medium:4, low:1 },
    baggage:      { tech:10, management:10, analysis:7, writing:2, humanities:1, visual:1, sales:1, design:1 },
  },
  "Gestor de Operações Digitais": {
    cognitive:    { analytic:9, strategic:8, executor:3, creative:1 },
    operational:  { adaptive:9, routine:3, commercial:1, autonomous:1 },
    behavioral:   { operator:10, leader:5, hybrid:3, backstage:1, sales_high:1, sales_low:2, sales_medium:2, communicator:2, frontline:1 },
    motivational: { ambition:8, impact:3, security:3, autonomy:1 },
    risk:         { medium:9, high:2, low:2 },
    baggage:      { management:10, tech:8, analysis:7, writing:1, humanities:1, visual:1, sales:1, design:1 },
  },
  "Gerente de Projetos Digitais": {
    cognitive:    { strategic:9, analytic:6, executor:2, creative:1 },
    operational:  { adaptive:9, routine:2, commercial:1, autonomous:1 },
    behavioral:   { leader:9, operator:9, hybrid:2, communicator:1, sales_high:1, sales_low:1, sales_medium:1, backstage:1, frontline:1 },
    motivational: { ambition:8, impact:2, security:2, autonomy:1 },
    risk:         { medium:9, high:1, low:1 },
    baggage:      { management:10, analysis:6, tech:5, writing:2, humanities:3, visual:1, sales:1, design:1 },
  },

  // ── Comunidade & Customer ─────────────────────────────────────────────────
  "Gestor de Comunidade": {
    cognitive:    { creative:8, strategic:5, executor:2, analytic:1 },
    operational:  { adaptive:8, autonomous:3, routine:1, commercial:1 },
    behavioral:   { communicator:10, frontline:8, hybrid:5, leader:2, sales_high:1, sales_medium:2, sales_low:2, operator:1, backstage:1 },
    motivational: { impact:10, autonomy:3, ambition:2, security:1 },
    risk:         { medium:5, high:2, low:2 },
    baggage:      { humanities:10, writing:7, management:2, visual:2, analysis:1, sales:2, tech:1, design:1 },
  },
  "Gestor de Atendimento Digital": {
    cognitive:    { executor:8, analytic:4, strategic:2, creative:1 },
    operational:  { routine:8, adaptive:3, commercial:1, autonomous:1 },
    behavioral:   { communicator:9, operator:8, hybrid:3, leader:4, frontline:2, sales_high:1, sales_low:5, sales_medium:2, backstage:1 },
    motivational: { impact:8, security:7, ambition:1, autonomy:1 },
    risk:         { low:7, medium:5, high:1 },
    baggage:      { humanities:9, management:6, writing:3, sales:3, analysis:2, tech:1, visual:1, design:1 },
  },
  "Analista de Customer Success": {
    cognitive:    { analytic:8, executor:3, strategic:2, creative:1 },
    operational:  { adaptive:8, routine:4, commercial:1, autonomous:1 },
    behavioral:   { communicator:9, hybrid:4, operator:3, frontline:2, sales_high:1, sales_low:4, sales_medium:3, leader:1, backstage:1 },
    motivational: { impact:9, security:4, ambition:1, autonomy:1 },
    risk:         { medium:6, low:4, high:1 },
    baggage:      { humanities:9, analysis:6, management:3, writing:3, sales:3, tech:1, visual:1, design:1 },
  },
  "Analista de Customer Experience": {
    cognitive:    { analytic:9, strategic:5, executor:2, creative:2 },
    operational:  { adaptive:8, routine:2, autonomous:2, commercial:1 },
    behavioral:   { operator:8, communicator:7, hybrid:3, backstage:1, sales_high:1, sales_low:4, sales_medium:2, leader:2, frontline:1 },
    motivational: { impact:9, security:3, ambition:2, autonomy:2 },
    risk:         { medium:7, low:3, high:1 },
    baggage:      { analysis:9, humanities:5, management:5, writing:3, tech:3, sales:2, visual:1, design:1 },
  },
  "Suporte a Alunos e Usuários": {
    cognitive:    { executor:9, analytic:3, strategic:1, creative:1 },
    operational:  { routine:10, adaptive:2, commercial:1, autonomous:1 },
    behavioral:   { communicator:8, operator:8, backstage:7, hybrid:3, frontline:2, sales_high:1, sales_low:9, sales_medium:2, leader:1 },
    motivational: { security:10, impact:5, autonomy:1, ambition:1 },
    risk:         { low:10, medium:2, high:1 },
    baggage:      { humanities:9, management:2, writing:3, analysis:1, sales:3, tech:2, visual:1, design:1 },
  },

  // ── Tecnologia ────────────────────────────────────────────────────────────
  "Desenvolvedor Vibe Coder": {
    cognitive:    { analytic:9, creative:8, executor:3, strategic:1 },
    operational:  { autonomous:10, adaptive:2, routine:1, commercial:1 },
    behavioral:   { backstage:10, operator:5, hybrid:1, communicator:1, sales_high:1, sales_low:9, sales_medium:1, leader:1, frontline:1 },
    motivational: { autonomy:10, ambition:2, impact:1, security:1 },
    risk:         { high:3, medium:3, low:1 },
    baggage:      { tech:10, analysis:9, visual:2, management:1, writing:1, humanities:1, sales:1, design:2 },
  },
};

// Pesos por dimensão — comportamental aumentado para diferenciar melhor
// liderança vs execução (era 0.20, agora 0.25)
const WEIGHTS = {
  cognitive: 0.25,
  behavioral: 0.25,
  operational: 0.10,
  motivational: 0.15,
  risk: 0.10,
  baggage: 0.15,
};

export function calculateResult(answers) {
  const scores = {};

  for (const [profession, matrix] of Object.entries(PROFESSION_MATRIX)) {
    let totalWeighted = 0;
    const dimScores = {};

    for (const [dim, dimWeight] of Object.entries(WEIGHTS)) {
      const dimMatrix = matrix[dim] || {};
      const dimQuestions = QUESTIONS.filter(q => q.dimension === dim);
      let dimScore = 0;

      for (const q of dimQuestions) {
        const answerValue = answers[q.id];
        if (answerValue) {
          dimScore += dimMatrix[answerValue] || 0;
        }
      }

      // Normaliza contra o máximo real atingível para esta profissão nesta dimensão
      let maxAchievable = 0;
      for (const q of dimQuestions) {
        const maxForQ = Math.max(0, ...q.options.map(opt => dimMatrix[opt.value] ?? 0));
        maxAchievable += maxForQ;
      }

      // Power curve (exponent 1.5) amplifica diferenças entre match bom e medíocre
      const ratio = maxAchievable > 0 ? dimScore / maxAchievable : 0.5;
      const normalized = Math.pow(ratio, 1.5) * 10;
      dimScores[dim] = Math.round(normalized * 10) / 10;
      totalWeighted += normalized * dimWeight;
    }

    scores[profession] = {
      rawTotal: Math.min(100, Math.round(totalWeighted * 10)),
      dims: dimScores,
    };
  }

  // Rescale: mapeia [min, max] raw → [15, 97] para spread visual significativo
  const rawTotals = Object.values(scores).map(s => s.rawTotal);
  const rawMin = Math.min(...rawTotals);
  const rawMax = Math.max(...rawTotals);
  const spread = rawMax - rawMin;

  for (const profession of Object.keys(scores)) {
    if (spread > 0) {
      scores[profession].total = Math.round(15 + ((scores[profession].rawTotal - rawMin) / spread) * 82);
    } else {
      scores[profession].total = 50;
    }
  }

  const ranked = Object.entries(scores)
    .map(([name, s]) => ({ name, score: s.total, dims: s.dims }))
    .sort((a, b) => b.score - a.score);

  return {
    topProfessions: ranked,
    dimensionScores: scores[ranked[0]?.name]?.dims || {},
    cognitiveProfile: deriveCognitiveProfile(answers),
    riskProfile: deriveRiskProfile(answers),
    baggageProfile: deriveBaggageProfile(answers),
    skillProfile: deriveSkillProfile(answers),
  };
}

// FIX: usa reduce com ordem fixa para garantir resultado determinístico em empates
function deriveCognitiveProfile(answers) {
  const map = { analytic: 0, creative: 0, strategic: 0, executor: 0 };
  for (const q of QUESTIONS.filter(q => q.dimension === "cognitive")) {
    const v = answers[q.id];
    if (v && map[v] !== undefined) map[v]++;
  }
  const ORDER = ["analytic", "creative", "strategic", "executor"];
  return ORDER.reduce((best, key) => map[key] > map[best] ? key : best, ORDER[0]);
}

// FIX: usa reduce com ordem fixa para garantir resultado determinístico em empates
function deriveRiskProfile(answers) {
  const map = { high: 0, medium: 0, low: 0 };
  for (const q of QUESTIONS.filter(q => q.dimension === "risk")) {
    const v = answers[q.id];
    if (v && map[v] !== undefined) map[v]++;
  }
  const ORDER = ["high", "medium", "low"];
  return ORDER.reduce((best, key) => map[key] > map[best] ? key : best, ORDER[0]);
}

// bag_1 e bag_2 usam chaves distintas — retorna diretamente o valor de bag_1 (área de origem)
function deriveBaggageProfile(answers) {
  return answers["bag_1"] || "humanities";
}

// Retorna o valor de bag_2 (habilidade dominante) como dimensão separada
function deriveSkillProfile(answers) {
  return answers["bag_2"] || "management";
}
